export default { sha: '2fa8c79bef2114e0bf0ac96d9d2466037dbac391', buildNumber: 'undefined' }
